module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.model === 'Shared') ? _c('div', [_c('shared-model', {
    attrs: {
      "row-data": _vm.billData,
      "title": _vm.title,
      "site-id": _vm.siteId,
      "tax": _vm.tax
    }
  })], 1) : _c('div', [_c('indivdual-model', {
    attrs: {
      "row-data": _vm.billData,
      "title": _vm.title,
      "site-id": _vm.siteId,
      "tax": _vm.tax
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1da9d902"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utility/UtilitySharingTable.vue
// module id = 1449
// module chunks = 0